export default __webpack_public_path__ + "static/media/FreightBigPro.77421159.ttf";